import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as eSignAPI from "./eSignAPI";

// Async thunk for fetching party details
export const fetchPartyDetailsEsign = createAsyncThunk(
  "eSign/fetchPartyDetailsEsign",
  async (PDE_ID, { rejectWithValue }) => {
    try {
      const data = await eSignAPI.fetchPartyDetailsEsign(PDE_ID);
      return data; // Return the fetched data
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const sendEmailLinkToParties = createAsyncThunk(
  "eSign/sendEmailLinkToParties",
  async (payload, { rejectWithValue }) => {
    try {
      const data = await eSignAPI.sendEmailLinkToParties(payload);
      return data; // Return the fetched data
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const checkEsignStatus = createAsyncThunk(
  "eSign/checkEsignStatus",
  async (PDE_ID, { rejectWithValue }) => {
    try {
      const data = await eSignAPI.checkEsignStatus(PDE_ID);
      return data; // Return the fetched data
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const fetchesignStatus = createAsyncThunk(
  "eSign/checkEsignStatus",
  async (PDE_ID, { rejectWithValue }) => {
    try {
      const data = await eSignAPI.fetchesignStatus(PDE_ID);
      return data; // Return the fetched data
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

const eSignSlice = createSlice({
  name: "eSign",
  initialState: {
    data: [],
    loading: false,
    error: null,
    statusData: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartyDetailsEsign.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPartyDetailsEsign.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPartyDetailsEsign.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(checkEsignStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkEsignStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.statusData = action.payload;
      })
      .addCase(checkEsignStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default eSignSlice.reducer;
